
(function() {
  var result = { translations: { "ms": { "i18n": { "duration": { "seconds": "{{ seconds }} saat", "minutes": "{{ minutes }} min", "hours": "{{ hours }} jam", "hoursAndMinutes": "{{ hours }} jam {{ minutes }} min", "days": "{{ days }} hari", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}j", "days": "{{ days }}h", "hoursAndMinutes": "{{ hours }}j {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, samb. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ms": "static-7.1084"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1084",
    "ar-eg": "static-7.1084",
    "bg": "static-7.1084",
    "bn": "static-7.1084",
    "ca-es": "static-7.1084",
    "cs": "static-7.1084",
    "da": "static-7.1084",
    "de": "static-7.1084",
    "el": "static-7.1084",
    "en-gb": "static-7.1084",
    "en": "static-7.1084",
    "es-mx": "static-7.1084",
    "es": "static-7.1084",
    "et": "static-7.1084",
    "fi": "static-7.1084",
    "fr-ca": "static-7.1084",
    "fr": "static-7.1084",
    "he-il": "static-7.1084",
    "hi": "static-7.1084",
    "hr": "static-7.1084",
    "hu": "static-7.1084",
    "id": "static-7.1084",
    "it": "static-7.1084",
    "ja": "static-7.1084",
    "ko": "static-7.1084",
    "lt": "static-7.1084",
    "ms": "static-7.1084",
    "nl": "static-7.1084",
    "no": "static-7.1084",
    "pl": "static-7.1084",
    "pt-br": "static-7.1084",
    "pt-pt": "static-7.1084",
    "ro": "static-7.1084",
    "ru": "static-7.1084",
    "sk": "static-7.1084",
    "sl": "static-7.1084",
    "sv": "static-7.1084",
    "th": "static-7.1084",
    "tl": "static-7.1084",
    "tr": "static-7.1084",
    "uk": "static-7.1084",
    "vi": "static-7.1084",
    "x-pseudo": "static-7.1084",
    "zh-cn": "static-7.1084",
    "zh-hk": "static-7.1084",
    "zh-tw": "static-7.1084"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ms', {version: 'static-7.1084'}); }
})();


